import React from 'react'
import ReactApexChart from 'react-apexcharts'


function MultipleLineGraph() {
    const state = {
          
        series: [
        {
            name: "MVC",
            data: [
              {x:'01/01/2023', y:58},
              {x:'02/01/2023', y:29}, 
              {x:'03/01/2023', y:33}, 
              {x:'04/01/2023', y:46}, 
              {x:'05/01/2023', y:22}, 
              {x:'06/01/2023', y:32}, 
              {x:'07/01/2023', y:30}]
        },
        {
            name: "STS",
            data: [
              {x:'01/01/2023', y:12}, 
              {x:'02/01/2023', y:11}, 
              {x:'03/01/2023', y:14}, 
              {x:'04/01/2023', y:18}, 
              {x:'05/01/2023', y:17}, 
              {x:'06/01/2023', y:13}, 
              {x:'07/01/2023', y:13}]
        },
        {
            name: "TUG",
            data: [
              {x:'01/01/2023', y:20}, 
              {x:'02/01/2023', y:12}, 
              {x:'03/01/2023', y: 24}, 
              {x:'04/01/2023', y:28}, 
              {x:'05/01/2023', y:37}, 
              {x:'06/01/2023', y:43}, 
              {x:'07/01/2023', y:53}]
        }
        ],
        options: {
          chart: {
              height: 300,
              width: 600,
              type: 'line',
              zoom: {
                  enabled: false
                },
              sparkline: {
                  enabled: true
              },
              dropShadow: {
                  enabled: true,
                  color: '#000',
                
              },
              toolbar: {
                  show: false
              }
          },
          colors: ['#028FD7', '#015681', '#001D2B'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
              width:3,
              curve: 'straight'
            },
          grid: {
              borderColor: '#e7e7e7',
              row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
              },
          },
          markers: {
            size: 4
          },
          tooltip: {
            enabled: true,
            shared: false,
            intersect: false,
            // style: {
            //   fontSize: '10px',
            //   fontFamily: undefined
            // },
            // marker: {
            //   show: false,
            // },
            followCursor:false,
      
          },
        },
    };


  return (
    <div>
      <div id="chart">
        <ReactApexChart options={state.options} series={state.series} type="line" height={350} />
      </div>
      <div id="html-dist"></div>
    </div>
  );


}
export default MultipleLineGraph